import { render, staticRenderFns } from "./HistoryModal.vue?vue&type=template&id=a675342e&scoped=true&"
import script from "./HistoryModal.vue?vue&type=script&lang=js&"
export * from "./HistoryModal.vue?vue&type=script&lang=js&"
import style0 from "./HistoryModal.vue?vue&type=style&index=0&id=a675342e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a675342e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
